// extracted by mini-css-extract-plugin
export default {"selected":"selected-rating_selected__v6a9K","selected__rating":"selected-rating_selected__rating__jgr01","selected__clear":"selected-rating_selected__clear__C19tV"};